import * as d3 from 'd3';
import { interpolateRdYlGn } from 'd3-scale-chromatic';

import { integerFormater, percentFormater } from './Formatters';

const range = (start, count = 10, step = 1) => {
  const empty = Array(count).fill();
  return empty.map((ignoredValue, index) => start + index * step);
};

const kiloDollarFormater = value => `$${Math.round(value / 1000)}k`;

const rateColorScale = d3.scaleSequential(interpolateRdYlGn).domain([0.0, 1.0]);
const earningsColorScale = d3.scaleSequential(interpolateRdYlGn).domain([0, 120000]);
const costColorScale = d3.scaleSequential(interpolateRdYlGn).domain([45000, 0]);
const satColorScale = d3.scaleSequential(interpolateRdYlGn).domain([800, 1600]);
const actColorScale = d3.scaleSequential(interpolateRdYlGn).domain([16, 36]);
const repaymentRateColorScale = d3.scaleSequential(interpolateRdYlGn).domain([0.2, 1.0]);

const rateValues = range(0.1, 10, 0.1);
const earningValues = range(20000, 11, 10000);
const costValues = range(0, 10, 5000);
const satValues = range(800, 9, 100);
const actValues = range(16, 11, 2);
const repaymentRateValues = range(0.2, 9, 0.1);

const smallBlockWidth = 60;
const blockHeight = 20;

const measures = [
  {
    key: 'ADM_RATE',
    label: 'Admission Rate',
    colorScale: rateColorScale,
    calculateFill: d => (d.ADM_RATE === null ? 'grey' : rateColorScale(d.ADM_RATE)),
    formater: percentFormater,
    values: rateValues,
    blockWidth: smallBlockWidth,
    blockHeight,
    independentVariable: true,
    maxScatterScaleValue: 1,
  },
  {
    key: 'onTimeCompletionRate',
    label: 'Ontime Completion Rate',
    colorScale: rateColorScale,
    calculateFill: d =>
      d.onTimeCompletionRate === null ? 'grey' : rateColorScale(d.onTimeCompletionRate),
    formater: percentFormater,
    values: rateValues,
    blockWidth: smallBlockWidth,
    blockHeight,
    independentVariable: false,
    maxScatterScaleValue: 1,
  },
  {
    key: 'extraTimeCompletionRate',
    label: 'Extra Time Completion Rate',
    colorScale: rateColorScale,
    calculateFill: d =>
      d.extraTimeCompletionRate === null ? 'grey' : rateColorScale(d.extraTimeCompletionRate),
    formater: percentFormater,
    values: rateValues,
    blockWidth: smallBlockWidth,
    blockHeight,
    independentVariable: false,
    maxScatterScaleValue: 1,
  },
  {
    key: 'MN_EARN_WNE_P10',
    label: 'Earnings Ten Years after Enrollment',
    colorScale: earningsColorScale,
    calculateFill: d =>
      d.MN_EARN_WNE_P10 === null ? 'grey' : earningsColorScale(d.MN_EARN_WNE_P10),
    formater: kiloDollarFormater,
    values: earningValues,
    blockWidth: smallBlockWidth,
    blockHeight,
    independentVariable: false,
    maxScatterScaleValue: 150 * 1000,
  },
  {
    key: 'RPY_7YR_RT',
    label: 'Repayment Progress 7 Years Later',
    colorScale: repaymentRateColorScale,
    calculateFill: d => (d.RPY_7YR_RT === null ? 'grey' : repaymentRateColorScale(d.RPY_7YR_RT)),
    formater: percentFormater,
    values: repaymentRateValues,
    blockWidth: smallBlockWidth,
    blockHeight,
    independentVariable: false,
    maxScatterScaleValue: 1,
  },
  {
    key: 'netPrice',
    label: 'Net Price',
    colorScale: costColorScale,
    calculateFill: d => (d.netPrice === null ? 'grey' : costColorScale(d.netPrice)),
    formater: kiloDollarFormater,
    values: costValues,
    blockWidth: smallBlockWidth,
    blockHeight,
    independentVariable: true,
    maxScatterScaleValue: 50 * 1000,
  },
  {
    key: 'TUITIONFEE_IN',
    label: 'In State Tuition',
    colorScale: costColorScale,
    calculateFill: d => (d.TUITIONFEE_IN === null ? 'grey' : costColorScale(d.TUITIONFEE_IN)),
    formater: kiloDollarFormater,
    values: costValues,
    blockWidth: smallBlockWidth,
    blockHeight,
    independentVariable: true,
    maxScatterScaleValue: 55 * 1000,
  },
  {
    key: 'TUITIONFEE_OUT',
    label: 'Out of State Tuition',
    colorScale: costColorScale,
    calculateFill: d => (d.TUITIONFEE_OUT === null ? 'grey' : costColorScale(d.TUITIONFEE_OUT)),
    formater: kiloDollarFormater,
    values: costValues,
    blockWidth: smallBlockWidth,
    blockHeight,
    independentVariable: true,
    maxScatterScaleValue: 55 * 1000,
  },
  {
    key: 'satCombinedMid',
    label: 'Median SAT',
    colorScale: satColorScale,
    calculateFill: d => (d.satCombinedMid === null ? 'grey' : satColorScale(d.satCombinedMid)),
    formater: integerFormater,
    values: satValues,
    blockWidth: smallBlockWidth,
    blockHeight,
    independentVariable: true,
    maxScatterScaleValue: 1600,
  },
  {
    key: 'ACTCMMID',
    label: 'Median ACT',
    colorScale: actColorScale,
    calculateFill: d => (d.ACTCMMID === null ? 'grey' : actColorScale(d.ACTCMMID)),
    formater: integerFormater,
    values: actValues,
    blockWidth: smallBlockWidth,
    blockHeight,
    independentVariable: true,
    maxScatterScaleValue: 35,
  },
];

export { measures };



// WEBPACK FOOTER //
// ./src/App/Measures.js